import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom'; // ✅ For navigation
import studentId from '../config';

const ViewProfile = () => {
  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  const navigate = useNavigate(); // ✅ Hook to navigate

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768); // Mobile if width < 768px
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const fetchStudent = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/students/getStudents/${studentId}`,
            {
    params: {
      sessionId: localStorage.getItem("currentSessionId"),
    },
  }
        );
        setStudent(response.data);

        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };
    fetchStudent();
  }, []);

  if (loading) return <div className="text-center py-6">Loading...</div>;
  if (error) return <div className="text-center py-6 text-red-500">Error: {error}</div>;

  const handleEditClick = () => {
    navigate(`/edit-profile/${studentId}`);
  };

  const content = (
    <div className="bg-white min-h-screen p-6">
      <div className="max-w-7xl mx-auto">
        <header className="mb-8 flex flex-col sm:flex-row justify-between items-center">
          <h1 className={`text-3xl font-semibold ${isMobile ? 'text-center mb-4' : 'text-left'}`}>
            Student Profile
          </h1>
          <button
            onClick={handleEditClick}
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md shadow-md transition"
          >
            Edit Profile
          </button>
        </header>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {/* Profile Image */}
          <div className="flex justify-center row-span-3">
            <img
              src={student.image || '/default-avatar.png'}
              alt={`${student.firstName} ${student.lastName}`}
              className="rounded-lg shadow-lg w-64 h-64 object-cover"
            />
          </div>

          {/* Name */}
          {student.firstName && student.lastName && (
            <InfoCard
              icon="fas fa-user"
              iconColor="#4CAF50"
              label="Name"
              value={`${student.firstName} ${student.lastName}`}
            />
          )}

          {/* Father's Name */}
          {student.fatherName && (
            <InfoCard icon="fas fa-male" iconColor="#2196F3" label="Father's Name" value={student.fatherName} />
          )}

          {/* Mother's Name */}
          {student.motherName && (
            <InfoCard icon="fas fa-female" iconColor="#FF4081" label="Mother's Name" value={student.motherName} />
          )}

          {/* Phone Number */}
          {student.phoneNo && (
            <InfoCard icon="fas fa-phone" iconColor="#FF9800" label="Phone Number" value={student.phoneNo} />
          )}

          {/* Alternate Phone */}
          {student.phoneNo2 && (
            <InfoCard icon="fas fa-phone-alt" iconColor="#8BC34A" label="Alternate Phone" value={student.phoneNo2} />
          )}

          {/* Email */}
          {student.email && (
            <InfoCard icon="fas fa-envelope" iconColor="#9C27B0" label="Email" value={student.email} />
          )}

          {/* Gender */}
          {student.gender && (
            <InfoCard icon="fas fa-venus-mars" iconColor="#3F51B5" label="Gender" value={student.gender} />
          )}

          {/* DOB */}
          {student.dob && (
            <InfoCard
              icon="fas fa-birthday-cake"
              iconColor="#FF5722"
              label="Date of Birth"
              value={new Date(student.dob).toLocaleDateString()}
            />
          )}

          {/* Age */}
          {student.age && <InfoCard icon="fas fa-hourglass-half" iconColor="#4CAF50" label="Age" value={student.age} />}

          {/* State */}
          {student.state && <InfoCard icon="fas fa-landmark" iconColor="#607D8B" label="State" value={student.state} />}

          {/* City */}
          {student.city && <InfoCard icon="fas fa-city" iconColor="#03A9F4" label="City" value={student.city} />}

          {/* Address */}
          {student.address && (
            <InfoCard icon="fas fa-map-marker-alt" iconColor="#795548" label="Address" value={student.address} />
          )}
        </div>
      </div>
    </div>
  );

  return content;
};

// Reusable InfoCard component
const InfoCard = ({ icon, iconColor, label, value }) => (
  <div className="bg-gray-100 p-4 rounded-lg shadow-md">
    <strong className="block text-gray-700 text-[18px]">
      <i className={`${icon} mr-2`} style={{ color: iconColor }}></i>
      {label}:
    </strong>
    <div className="text-gray-900" style={{ fontSize: '12px' }}>
      {value}
    </div>
  </div>
);

export default ViewProfile;
